var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zhengxuangu-box"},[_vm._l((_vm.parseAnswers),function(item){return [(item.show_type === 'txt2')?_c('txt2',{attrs:{"configData":item.components[0]}}):_c('zhenxuangu',{attrs:{"answers":item,"intent":_vm.session.response.answer[0].intent}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }